import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {NineToFive} from "../../NineToFive";
import {NineToFiveXWaysSymbol} from "../../reels/symbols/XWaysSymbol";
import {NineToFiveWildSymbol} from "../../reels/symbols/WildSymbol";


/**
 * Created by jonas on 2022-01-12.
 */

export class RevealWilds implements SimplePresentation {

    name:string = "RevealXWays";

    constructor() {
    }

    shouldRun():boolean {
        return this.getWildSymbols().length > 0
    }

    private getWildSymbols():NineToFiveWildSymbol[] {
        return <NineToFiveWildSymbol[]>NineToFive.baseGameReelView.getAllSymbols().filter((sym) => sym.symbolName == "W");
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline({
            onStart: () => {
                controller.setSkipCallback(() => {tl.seek("End", false)});
            },
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish()
            }
        });
        this.getWildSymbols().forEach((sym) => {
            tl.add(sym.revealMultiplier(), '>0.1');
            tl.add(sym.multiplier > 0
                   ? () => {NineToFive.soundPlayer.playSound("wildAccepted")}
                   : () => {NineToFive.soundPlayer.playSound("wildDenied")}, '<');
        })
        //.add(() => {TheCage.soundPlayer.playSound("xWaysReveal")}, '<')
        tl.addLabel("End")
        tl.add(() => {}, '>0.3');
    }
}
